import {
  Box,
  ClickAwayListener,
  Grow,
  Link,
  ListItemIcon,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Typography,
  makeStyles
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  menu: {
    color: theme.palette.primary.contrastText,
    padding: '13px 20px',
    '&:hover': {
      backgroundColor: 'inherit'
    }
  },
  item: {
    fontFamily: 'Roboto Condensed',
    fontWeight: 600,
    fontSize: `${13 / 16}rem`,
    color: theme.palette.primary.dark,
    padding: '10px 25px'
  },
  paper: {
    backgroundColor: theme.palette.background.default
  }
}));

const MenuEvents: React.FC = () => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<null | HTMLLIElement>(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: React.MouseEvent<EventTarget>) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event: React.KeyboardEvent) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current?.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <Box onMouseEnter={handleToggle} onMouseLeave={() => setOpen(false)}>
      <MenuItem className={classes.menu} ref={anchorRef} disableRipple>
        <Typography variant="h6">Events</Typography>
        <ListItemIcon style={{ minWidth: 'auto', marginLeft: '.5rem' }}>
          <ExpandMoreIcon fontSize="small" style={{ color: 'white' }} />
        </ListItemIcon>
      </MenuItem>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom'
            }}
          >
            <Paper className={classes.paper} square>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id="menu-list-grow"
                  disablePadding
                  onKeyDown={handleListKeyDown}
                  style={{ textTransform: 'uppercase' }}
                >
                  <MenuItem onClick={handleClose} className={classes.item}>
                    <Link href="http://awbd.org/calendar" underline="none">
                      Calendar
                    </Link>
                  </MenuItem>
                  <MenuItem onClick={handleClose} className={classes.item}>
                    <Link
                      href="http://awbd.org/awbd-events/conferences/"
                      underline="none"
                    >
                      Conferences
                    </Link>
                  </MenuItem>
                  <MenuItem onClick={handleClose} className={classes.item}>
                    <Link
                      href="http://awbd.org/awbd-events/parks/"
                      underline="none"
                    >
                      Parks
                    </Link>
                  </MenuItem>
                  <MenuItem onClick={handleClose} className={classes.item}>
                    <Link
                      href="http://awbd.org/awbd-events/past-events/"
                      underline="none"
                    >
                      Past Events
                    </Link>
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Box>
  );
};

export default MenuEvents;
